import React, {useState, useEffect} from "react";
import OtpPoupupImg from "../Assets/OtpPoupup.png";
import { validatePassword } from "../../../../Components/ReuseableFunctions/ValidationFunctions";
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";
import errorMessageImage from "../Assets/SurePopup.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import InstructionPopup from "./InstructionPopup";
import bulletIcon from "../Assets/greenTick.svg";

const CreateNewPasswordSettingsPopup = ({userEmail, setCreateNewPasswordShowPopup, setPasswordResetSuccessShowPopup, UserId }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [bothPasswordError, setBothPasswordError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [passwordValidationError, setPasswordValidationError] = useState("");
  const [instructionPopup, setInstructionPopup] = useState("");
  const [passwordStrength, setPasswordStrength] = useState({ level: 0, label: "", color: "" });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const isPasswordValid = (password) => password.length >= 8;

  const matchBothPasswords = async () => {
    // Validate new password and confirm password match
    setBothPasswordError("")
    if (newPassword !== confirmPassword) {
      setBothPasswordError("Passwords do not match.");
      return;
    }
  
    if (!isPasswordValid(newPassword)) {
      setBothPasswordError("Password must be at least 8 characters.");
      return;
    }
  };

  const closePopup = () =>{
      console.log("Close icon clicked");
      setCreateNewPasswordShowPopup(false);
  }

  const OpenCreatePasswordPopup = () =>{
      setPasswordResetSuccessShowPopup(true)
      setCreateNewPasswordShowPopup(false);
  }

  const getPasswordStrength = (password) => {
    let score = 0;
  
    // Check each requirement
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;
  
    // Determine strength
    if (score <= 1) return { level: 1, label: "Weak", color: "#EE170E" };
    if (score === 2 || score === 3) return { level: 2, label: "Medium", color: "#FFD704" };
    if (score >= 4) return { level: 3, label: "Strong", color: "#50EE59" };
  };
  

  const handleChangePassword = async () => {
    // Reset messages
    setErrorMessage("");
    setSuccessMessage("");

    // Check for empty fields
    if (!newPassword || !confirmPassword) {
      if (!newPassword) {
      setErrorMessage("Please enter a new password.");
      } else if (!confirmPassword) {
      setErrorMessage("Please re-enter your new password.");
      }
      return;
  }

  // Validation checks before sending the request
  if (
      (Array.isArray(passwordValidationError) && passwordValidationError.length > 0) ||
      (typeof passwordValidationError === "string" && passwordValidationError.trim() !== "") ||
      newPassword !== confirmPassword
    ) {
      if (Array.isArray(passwordValidationError) && passwordValidationError.length > 0) {
        setErrorMessage("Password doesn't follow the instructions."); // show first error in array
      } else if (typeof passwordValidationError === "string" && passwordValidationError.trim() !== "") {
        setErrorMessage("Password doesn't follow the instructions."); // show string directly
      } else if (newPassword !== confirmPassword) {
        setErrorMessage("New Password and Confirm Password do not match.");
      }
      return;
    }
    

    try {
      // Send data to backend
      const response = await fetch("/api/settings/change-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword, UserId, userEmail }),
      });

      const result = await response.json();

      if (response.ok) {
        setPasswordResetSuccessShowPopup(true)
        setCreateNewPasswordShowPopup(false);
      } else {
        setErrorMessage(result.message || "An error occurred.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    const errors = validatePassword(value);
    setPasswordValidationError(errors);

    const strength = getPasswordStrength(value);
    setPasswordStrength(strength);
  };

  const InstructionText = () => (
    <>
      • At least 8 characters<br />
      • One uppercase and one lowercase letter<br />
      • At least one number<br />
      • At least one special character (e.g. @, #, $)
    </>
  );

  const passwordInstructions = (
    <div className="">
      <div className="flex items-start">
        <img src={bulletIcon} alt="bullet" className="w-4 h-4 mt-1 mr-1" />
        <span>Password must be at least 8 characters</span>
      </div>
      <div className="flex items-start">
        <img src={bulletIcon} alt="bullet" className="w-4 h-4 mt-1 mr-1" />
        <span>Password must include one uppercase alphabet</span>
      </div>
      <div className="flex items-start">
        <img src={bulletIcon} alt="bullet" className="w-4 h-4 mt-1 mr-1" />
        <span>Password must include one lowercase alphabet</span>
      </div>
      <div className="flex items-start">
        <img src={bulletIcon} alt="bullet" className="w-4 h-4 mt-1 mr-1" />
        <span>Password must include at least one number (0-9)</span>
      </div>
      <div className="flex items-start">
        <img src={bulletIcon} alt="bullet" className="w-4 h-4 mt-1 mr-1" />
        <span>Password must include at least one special symbol</span>
      </div>
    </div>
  );
  
  
    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[10px] shadow-lg w-[340px] lg:w-[380px]">
        <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
        </div>

        <div  className="mt-[-100px] flex w-full justify-center items-center">
          <img
            src={OtpPoupupImg}
            alt="img"
          />
        </div>
          
          <h2
            className="text-center text-[16px] mt-[-15px]"
          >
            Create New Password
          </h2>
          <p className="text-center text-[14px]">Enter a new password below to change your password, according to these <span className="text-[#1604FF] underline cursor-pointer" onClick={() => setInstructionPopup(true)}>instructions</span></p>
          <div className="w-full flex flex-col gap-[10px] mt-[10px] mr-[15px]">
                <div className="flex justify-between">
                    <label
                        htmlFor="New Password"
                        className="text-[#404040] text-[16px]"
                    >
                        New Password
                    </label>
                    {/* {passwordValidationError && <p className="text-[#ff0000] text-[16px]">{passwordValidationError} </p>}  */}
                </div>
                <div className="relative">
                    <input
                        type={showNewPassword ? "text" : "password"}
                        id="New Password"
                        placeholder="Enter New Password"
                        value={newPassword}
                        // onChange={(e) => setNewPassword(e.target.value)}
                        onChange={handleNewPasswordChange}
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />
                    <span
                          className="absolute top-[45%] right-[10px] transform -translate-y-1/2 cursor-pointer"
                          onClick={() => setShowNewPassword((prev) => !prev)}
                        >
                        {showNewPassword ? <AiFillEyeInvisible  size={20} /> : <AiFillEye size={20} />}
                      </span>
                  </div>
         </div>
         <div className="w-full flex flex-col gap-[10px] mt-[10px] mr-[15px] ">
                <label
                    htmlFor="New Password"
                    className="text-[#404040] text-[16px]"
                >
                    Re-enter New Password
                </label>
                <div className="relative">
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="New Password"
                        placeholder="Re-enter New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onBlur={matchBothPasswords} // Validate on blur
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />
                  <span
                          className="absolute top-[45%] right-[10px] transform -translate-y-1/2 cursor-pointer"
                          onClick={() => setShowConfirmPassword((prev) => !prev)}
                        >
                        {showConfirmPassword ? <AiFillEyeInvisible  size={20} /> : <AiFillEye size={20} />}
                      </span>
                  </div>
         </div>

         {/* <p className="text-[14px] mt-[10px]">Please create a secure password that is exactly 8 characters long and includes at least one uppercase letter, one number, and one special character.</p> */}
         {/* <div className="w-full flex flex-col mt-[10px]">
            <div className="w-full flex">
                  <div className="w-[41px] h-[5px] bg-[#EE170E]"></div>
                  <div className="w-[41px] h-[5px] bg-[#FFD704]"></div>
                  <div className="w-[41px] h-[5px] bg-[#50EE59]"></div>
            </div>
            <p className="text-[10px] text-[#50EE59]">Strong</p>
          </div> */}

          {errorMessage && <p className="text-[#ff0000] text-[16px]">{errorMessage} </p>}
          {bothPasswordError && <p className="text-[#ff0000] text-[16px]">{bothPasswordError}</p>}

          {newPassword && (
              <div className="w-full flex flex-col mt-[10px]">
                  <div className="w-full flex">
                    {[1, 2, 3].map((level) => (
                      <div
                        key={level}
                        className={`w-[41px] h-[5px] ${
                          passwordStrength.level >= level ? "" : "bg-[#979494]"
                        }`}
                        style={{
                          backgroundColor:
                            passwordStrength.level >= level ? passwordStrength.color : "#979494",
                        }}
                      ></div>
                    ))}
                  </div>

                  {passwordStrength.label && (
                    <p className={`text-[10px] mt-1`} style={{ color: passwordStrength.color }}>
                      {passwordStrength.label}
                    </p>
                  )}
              </div> 
          )}

         <div className="w-full flex justify-center items-center gap-[15px] mt-[20px] mb-[20px]">
            <button
                className="py-[7px] w-[150px] rounded-[6px] text-[#A1A3EF] text-[14px] cursor-pointer"
                style={{border:"2px solid #A1A3EF"}}
                onClick={closePopup}>
               Cancel
            </button>
            <button
                className="px-[15px] py-[7px]  w-[150px] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleChangePassword}
                style={{border:"2px solid #A1A3EF"}}>
               Reset Password
            </button>
          </div>

          {instructionPopup && (
                <InstructionPopup
                setShowPopup={setInstructionPopup}
                heading="Password Instruction"
                text={passwordInstructions}
                btnText="Done"
                onClick={() => setInstructionPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}

          {/* <div className="w-full flex justify-center items-center gap-[15px] mt-[15px]">
            <button
                className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleChangePassword}
                style={{border:"2px solid #A1A3EF"}}>
                Reset Password
            </button>

            <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Cancel</p>
          </div> */}
        </div>
      </div>
    );
  };

export default CreateNewPasswordSettingsPopup;
